import * as Yup from "yup";

export const scheduleSchema = Yup.object().shape({
  user_id: Yup.number()
    .nullable()
    .typeError("O funcionário deve ser um número")
    .positive("O ID do funcionário deve ser um número válido"),

  client_id: Yup.number()
    .nullable()
    .transform((value) => (value === -1 ? null : value)),
  products: Yup.array()
    .of(
      Yup.object().shape({
        id: Yup.number()
          .nullable()
          .typeError("ID do produto deve ser um número")
          .positive("ID do produto deve ser válido"),

        quantity: Yup.number()
          .required("A quantidade do produto é obrigatória")
          .typeError("Quantidade deve ser um número")
          .min(1, "A quantidade mínima do produto é 1"),
      }),
    )
    .nullable(),

  service_id: Yup.array().when("type", {
    is: (val: string) => val !== "blocked",
    then: (schema) =>
      schema
        .required("É obrigatório informar ao menos um serviço")
        .min(1, "É obrigatório informar ao menos um serviço")
        .of(
          Yup.number()
            .typeError("Cada serviço deve ser um ID numérico válido")
            .integer("Cada serviço deve ser um número inteiro")
            .positive("Cada serviço deve ser um número válido"),
        ),
    otherwise: (schema) => schema.nullable(),
  }),

  // Optional helper array used by the UI to track which tab/origin a service
  // was selected from ("subscription" | "single" | "package"). Not persisted
  // as-is to the backend but used to decide `use_subscription` on submit.
  service_origin: Yup.array()
    .of(Yup.string().oneOf(["subscription", "single", "package"]))
    .nullable(),

  start_date_time: Yup.string().required(
    "A data e hora de início são obrigatórias",
  ),

  closing_date_time: Yup.date()
    .nullable()
    .test(
      "after-start-date",
      "A data de término deve ser posterior à data de início",
      function (value) {
        const { start_date_time } = this.parent;
        if (value && start_date_time) {
          return new Date(value) >= new Date(start_date_time);
        }
        return true;
      },
    ),

  type: Yup.string().nullable(),

  status: Yup.string().nullable(),

  is_fit_in: Yup.boolean().nullable(),

  description: Yup.string().nullable(),

  duration: Yup.number()
    .nullable()
    .transform((value, originalValue) => {
      // Converter string vazia ou undefined para null
      if (
        originalValue === "" ||
        originalValue === null ||
        originalValue === undefined
      ) {
        return null;
      }
      // Se já for número, retornar
      if (typeof originalValue === "number") {
        return originalValue;
      }
      // Tentar converter string para número
      const num = Number(originalValue);
      return isNaN(num) ? null : num;
    })
    .typeError("A duração deve ser um número")
    .min(5, "A duração mínima é 5 minutos")
    .positive("A duração deve ser um número positivo"),
});
